/**
 * Facility 周边设施
 * 
 * @Author: Focci
 * @Date: 2023-07-18 14:42:52
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-18 14:42:52
 */

'use client'

import PropTypes from 'prop-types'
import clsx from 'clsx'
import useFetch from '@hook/useFetch'
import FacilityMarkers from '@comp/mapbox/marker/FacilityMarkers'
import { useMapState } from '@comp/mapbox'
import { ButtonBase, Skeleton } from '@comp/material'
import { isArray } from 'lodash-es'
import { PanelScoff } from '../panel/PanelBody'

export function FacilityBody({ houseId }) {
  const { data, isLoading } = useFetch('local-amenity')
  const { facility, setFacility } = useMapState()
  
  if(isLoading) {
    return (
      <div className="bg-white min-w-60 p-3">
        <Skeleton />
        <Skeleton style={{ width: '80%' }} />
        <Skeleton style={{ width: '90%' }} />
      </div>
    )
  }
  
  return (
    <>
      <div className="bg-white w-full md:w-60 p-3 grid grid-cols-3 gap-2">
        {isArray(data) && data.map((item) => (
          <ButtonBase 
            key={item.value}
            onClick={() => setFacility(item.value)}
            className="rounded-md"
          >
            <div 
              className={clsx([
                'border border-gray-200 px-2 py-1 rounded-md w-full line-clamp-1',
                facility === item.value && 'bg-primary text-white'
              ])}
            >
              {item.label}
            </div>
          </ButtonBase>
        ))}
      </div>
      
      {/* 添加 marker */}
      {isArray(data) && data.map((item) => (
        item.value === facility && (
          <FacilityMarkers
            key={item.value} 
            houseId={houseId}
            type={item.value}
          />
        )
      ))}
    </>
  )
}

export default function Facility({
  houseId = null,
  ...panelProps
}) {
  return (
    <PanelScoff className="w-auto" {...panelProps}>
      <FacilityBody houseId={houseId} />
    </PanelScoff>
  )
}

Facility.propTypes = {
  houseId: PropTypes.number,
}
